import Timer from 'timer.js'
import path from 'path'
import url from 'url'

import EventEmitter from 'amkit3-modules/utils/stateful-events'
import playbackFactory from 'amkit3-modules/v/playbacks/factory'
import PlaybackEvent from 'amkit3-modules/v/playbacks/playback-event'

import ADEvent from './ad-event'

const FRONT_AD = '250701248091'

class HuyaAd extends EventEmitter {
  constructor($, container, ads, ready) {
    super()

    this.$ = $
    this.selector = require('./selector')
    this.style = require('./style.scssm')
    this.$container = this.$(container)
    this.$frontAdContainer = this.$container.find(this.selector.frontAdContainer)
    this.ads = ads

    this.frontAds = this.ads.filter(ad => ad.adLocation == FRONT_AD)
    this.frontAdTimer = new Timer({ tick: 1 })
    this.frontAdTimer.on('tick', sec => {
      this.$container.find(this.selector.frontAdCountdownSec).text(Math.max(0, Math.round(sec / 1000)))
    })
    // TODO 假装全是mp4
    this.frontAdResources = []
    this.frontAdResourcesLoadCount = 0
    if (this.frontAds.length) {
      this.frontAds.forEach(ad => {
        let ext = path.extname(url.parse(ad.fodderUrl).pathname).slice(1)
        switch(ext) {
          case 'mp4':
            playbackFactory.get(this.$frontAdContainer[0], { src: ad.fodderUrl }, (err, PlaybackConstructor, playback) => {
              if (!err) {
                this.frontAdResources.push({ playback, ad })
              }
              this.frontAdPlaybacksReady(ready)
            })
            break
          default:
            setTimeout(() => this.frontAdPlaybacksReady(ready), 0)
            break
        }
      })
    } else {
      setTimeout(ready, 0)
    }

    // event delegate
    this.$frontAdContainer.on('click', this.selector.frontAdCountdownMuteButton, evt => {
      if (this.frontAdPlayback) {
        if (this.frontAdPlayback.getVolume()) {
          this.frontAdPlayback.setVolume(0)
          this.$container.find(this.selector.frontAdCountdownMuteButton).addClass(this.style.frontAdCountdownMuteButtonOn)
        } else {
          this.frontAdPlayback.setVolume(1)
          this.$container.find(this.selector.frontAdCountdownMuteButton).removeClass(this.style.frontAdCountdownMuteButtonOn)
        }
      }
    })
    this.$frontAdContainer.on('click', this.selector.frontAdMask, evt => {
      if (this.frontAdCurrent) {
        this.emit(ADEvent.CLICK)
        window.open(this.frontAdCurrent.clickUrl, '_blank')
      }
    })
  }
  frontAdPlaybacksReady(ready) {
    this.frontAdResourcesLoadCount += 1
    if (this.frontAdResourcesLoadCount == this.frontAds.length) {
      ready()
    }
  }
  showFrontAd(cb) {
    this.$frontAdContainer.show()
    let mcb = () => { 
      this.$frontAdContainer.hide()
      cb()
    }
    if (!!this.frontAds.length) {
      let total = this.frontAds.reduce((prev, cur) => prev + cur.videoTime, 0)
      this.$container.find(this.selector.frontAdCountdownSec).text(total)
      this.frontAdTimer.start(total).on('end', mcb)
      this.showFrontAdResource()
    } else {
      this.emit(ADEvent.NO_AD)
      mcb();
      // setTimeout(mcb, 0)
    }
  }
  showFrontAdResource() {
    let resource = this.frontAdResources.shift()
    if (!resource) {
      if (!this.isError) {
        this.emit(ADEvent.COMPLETE)
      }
      return
    }
    this.frontAdPlayback = resource.playback
    this.frontAdCurrent = resource.ad
    let playTime = resource.ad.videoTime * 1000
    this.frontAdPlayback.play()
    this.frontAdPlayback.once(PlaybackEvent.PLAYING, () => this.emit(ADEvent.LOAD))
    this.frontAdPlayback.once(PlaybackEvent.ERROR, () => {
      this.isError = true
      this.emit(ADEvent.ERROR)
    })
    setTimeout(() => {
      this.frontAdPlayback.removeAllListeners()
      this.frontAdPlayback.destroy()
      this.frontAdPlayback = null
      this.frontAdCurrent = null
      this.showFrontAdResource()
    }, playTime)
  }
  getAid() {
    if (this.frontAdCurrent) return this.frontAdCurrent.adId
    else return ''
  }
  getAti() {
    if (this.frontAdCurrent) return this.frontAdCurrent.ati
    else return ''
  }
  getCode() {
    if (this.frontAdCurrent) return this.frontAdCurrent.code
    else return ''
  }
}

export default HuyaAd
